import _isEmpty from 'lodash/isEmpty'
import {
  StateType, IWithdrawalRequestData, IVipDice, IVipConfig, IBonusAnimationData, IReferralBonusAlertData
} from './interface'
import _get from 'lodash/get'

export function getZupeeUserId(state: any) {
  return state?.user?.userData?.zupeeUserId
}

export function getUsername(state: any) {
  return state?.user?.userData?.un
}

export function getWithdrawalRequestData(state: any): IWithdrawalRequestData {
  return {
    actualCoins: state?.user?.userData?.actualCoins,
    isUpiAvailable: !!state?.user?.userData?.upiId,
    isBankAvailable: !_isEmpty(state?.user?.userData?.bankDetails)
  }
}

export function getActualCoins(state: StateType): number {
  return _get(state, 'user.userData.actualCoins', 0)
}

export function getBonusCoins(state: StateType): number {
  return _get(state, 'user.userData.bonusCoins', 0)
}

export function getAddedCoins(state: StateType): number {
  return _get(state, 'user.userData.addedCoins', 0)
}

export function getCashbackCoins(state: StateType): number {
  return _get(state, 'user.userData.cashbackCoins', 0)
}

export function getVipConfig(state: StateType): IVipConfig {
  return _get(state, 'user.vipConfig', {})
}

export function getVipDiceInfo(state: StateType): IVipDice | null{
  return _get(state, 'user.userData.userExp.entities.dice', null)
}

export function getUserExp(state: StateType): Object{
  return _get(state, 'user.userData.userExp', {})
}

export function getCheckNudgeOnHomeScreen(state: StateType): boolean {
  return _get(state, 'user.checkNudgeOnHomeScreen', false)
}

export function getTotalCoins(state: StateType): number {
  return getActualCoins(state) + getBonusCoins(state) + getAddedCoins(state) + getCashbackCoins(state)
}

export function getUserOnboardingCompleted(state: StateType): boolean {
  return _get(state, 'user.onboardingCompleted', false)
}

export function getOnboardingOriginalSteps(state: StateType): [] {
  return _get(state, 'user.originalOnboardingSteps', [])
}

export function getOnboardingCurrentStepsIndex(state: StateType): number {
  return _get(state, 'user.currentStepsIndex', 0)
}

export function getReferralCode(state: StateType): string {
  return _get(state, 'user.referralCode', '')
}

export function getReferralBonusAlertData(state: StateType): IReferralBonusAlertData {
  return _get(state, 'user.referralBonusAlertData', {} as IReferralBonusAlertData)
}

export function getUserDataReferralCode(state: StateType): string {
  return _get(state, 'user.userData.referralCode', '')
}

export function getUserDataSignupPhoneNumber(state: StateType): string {
  return _get(state, 'user.userData.signupPhoneNumber', '')
}

export function getUserDataGoogleToken(state: StateType): string {
  return _get(state, 'user.userData.googleToken', '')
}

export function getAdjustCampaign(state: StateType): string {
  return _get(state, 'user.campaign', '')
}

export function getBonusAnimationData(state: StateType): IBonusAnimationData {
  return _get(state, 'user.bonusAnimationData', {} as IBonusAnimationData )
}

export function getShowDGPScreen(state: StateType): boolean {
  return _get(state, 'user.showDGPScreen', false)
}

export function getHomePageCarouselList(state: StateType): [] {
  return _get(state, 'user.filteredWidgetItemList', [])
}
